import { useQuery } from '@apollo/client';
import React, { useMemo } from 'react';

import {
  ColDefBuilder,
  DataTable,
  Heading,
  LinkButton,
  Stack,
  Text,
} from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';

const getTenantMlEngineersListQuery = graphql(`
  query getTenantMlEngineersList {
    tenantMlEngineers {
      __typename
      userId
      tenantId
      tenant {
        name
      }
      user {
        email
        firstName
        lastName
      }
      createdAt
    }
  }
`);

type TenantMlEngineersRow = {
  tenantId: string;
  tenant: string;
  userId: string;
  userEmail: string;
  user: string;
  addedAt: string;
};

export const MlEngineersListPage: React.FC = () => {
  const { data } = useQuery(getTenantMlEngineersListQuery);

  const columns = new ColDefBuilder<TenantMlEngineersRow>()
    .linkSortable(
      'tenant',
      (row) => `/admin/organizations/${row.tenantId}`,
      'Organization',
    )
    .linkSortable('user', (row) => `/admin/users/${row.userId}`)
    .defaultSortable('userEmail', 'User Email')
    .dateSortable('addedAt', 'Added At')
    .colDef({
      header: 'Actions',
      cell: ({ row }) => (
        <LinkButton
          to={`/admin/organizations/${row.original.tenantId}/manage/ml-engineers`}
        >
          Modify
        </LinkButton>
      ),
    })
    .build();

  const rows = useMemo(() => {
    return (data?.tenantMlEngineers ?? []).map<TenantMlEngineersRow>((r) => ({
      tenantId: r.tenantId,
      tenant: r.tenant.name,
      userId: r.userId,
      userEmail: r.user.email,
      user: `${r.user.firstName} ${r.user.lastName}`,
      addedAt: r.createdAt,
    }));
  }, [data]);

  return (
    <Stack>
      <div className="my-2 py-2">
        <Heading>All ML Engineers</Heading>
      </div>

      <Text>
        An overview of all users that have ML-engineer access and to which
        organizations.
      </Text>
      <DataTable
        data={rows}
        columns={columns}
        isPaginated={false}
        enableGlobalSearch
        initialSortingState={[
          {
            id: 'user',
            desc: false,
          },
        ]}
      />
    </Stack>
  );
};
